import React from 'react';
import { WBNMap } from 'components/molecules';

import './styles.less';
import domain_brand from 'domain_brand';
import WBN_Network from 'images/about-us/WBN_WBNB2B_WORLDWIDE_NETWORK.png';
import PersonOne from 'images/about-us/PHOTO_CHRISTIAN.png';
import PersonTwo from 'images/about-us/PHOTO_MIGUEL.png';
import Button from 'components/atoms/button';
import Helmet from 'react-helmet';
import { TipSummary } from '../b2b-tips/tip0';

const TextWrapped = ({ children, className }) => {
	return (
		<div className={`about-us text-wrapped ${className ? className : ''}`}>
			{children}
		</div>
	)
}

const AboutUs = () => {
	window.scrollTo(0,0);
	return (
		<div>
			<Helmet>
				<title>{`WBN is an American Industrial B2B Social Network, created to help democratically distributors, buyers, suppliers and manufacturers to establish develop business relationship in the most important markets, WBN industrial social network business to business`}</title>
				<meta name="description" content={`WBN is an industrial B2B social network create to support the ${process.env.REACT_APP_SEO_FIRST} export to manufacturers business supplies, made in ${process.env.REACT_APP_SEO_SECOND} industrial B2B manufacturing products and manufacturer business centre, ${process.env.REACT_APP_SEO_FIRST} industries of production companies an industrial B2B Social Network to offer your best export global experience, made in ${process.env.REACT_APP_SEO_SECOND} We help companies to connect with B2B distributors, buyers and industrial manufacturers to establish and/or to improve business relationship, confidence and profit at very low cost, making Import and Export trade available for everyone in few clicks. ${process.env.REACT_APP_SEO_FIRST} B2B industrial export IT manufacturing supplies, made in ${process.env.REACT_APP_SEO_SECOND} manufacturing vendors for B2B global distributors, WBN your best source of manufacturer suppliers and vendors, ${process.env.REACT_APP_SEO_FIRST} business guide is part of WBN industrial b2b social network, made in ${process.env.REACT_APP_SEO_SECOND} export products manufacturing business supply, ${process.env.REACT_APP_SEO_FIRST} products for wholesale business distributors in United States, Asia, Africa, Europe, South America, Latin America and Middle East distribution, WBN the industrial b2b social network for wholesalers and manufacturing private label industries, made in ${process.env.REACT_APP_SEO_SECOND} products manufacturer supplier for wholesalers and vendors of the market, industrial products for wholesale worldwide distributors, ${process.env.REACT_APP_SEO_FIRST} electronic products manufacturing for private label buyers and new brand for manufacturer, business to business manufacturing supplies and market distributors, ${process.env.REACT_APP_SEO_FIRST} product manufacturing industry looking for worldwide distributors mainly in Germany, Denmark, Austria, Portugal, Spain, France, Norway, Sweden in Europe, China, Japan, Korea, Vietnam in Asia, California, New York, Florida, Chicago Illinois and all the United States of America, South Arabia, Qatar, Oman, UAE, Middle East, Australia, North of Africa, South America and all Latin America`}/>
				<meta name="keywords" content={`WBN social network,  ${process.env.REACT_APP_SEO_FIRST} social network, distributors social network, manufacturers social network, b2b social network, industrial social network, ${process.env.REACT_APP_SEO_SECOND} social network`}/>
			</Helmet>
			<div>
				<p style={{ textAlign: "center", padding: "5px 10px" }}>
					WORLDWIDE BUSINESS NETWORK INC. MIAMI (FL) U.S. - ABOUT US
				</p>
				<p style={{ textAlign: "center", padding: "5px 10px" }}>
					Worldwide Network Guide (WBN) was created the 2000 as the only tool of new technology which allows
					small and medium industry to be immediately visible and operative in the most important
					"Business to Business" (B2B) markets in the world. Every company and products is presented
					professionally and launched in all our international and regional web portals of the network
					facilitating the direct synergy with the international markets with the aim to create
					a distribution network for each one.
				</p>
			</div>

			<div className="container-message">
				<div className="container-message__top">
					<div className="container-message__top-left">
						<TextWrapped>
							<p>Our TeamOur Team is Our Power: WBN was created and developed by a group of qualified professional engineers in several technology areas as Mechanical, Industrial, Computing...</p>
						</TextWrapped>
						<TextWrapped>
							<p>...manufacturing and B2B Global  Marketing, each one with a multicultural background, and from several countries, combining knowledge in synergy with a high end experience to offer the Best Global B2B Tool.</p>
						</TextWrapped>
					</div>
					<div className="container-message__top-middle">
						<div className="container-message__top-middle-image">
							<img src={domain_brand} alt='wbn brand' />
						</div>
					</div>
					<div className="container-message__top-right">
						<TextWrapped>
							<p>WBN as industrial B2B Network guarantees a perfect B2B connection between manufacturers, distributors, private label business, buyers and full players of the import and export worldwide industry</p>
						</TextWrapped>
						<TextWrapped>
							<p>Our goal: "Internationalization of manufacturing system: territory, industrial production, and culture into Europe, the United States, Central America, South America, Asia, Africa, Australia and the Middle East"</p>
						</TextWrapped>

					</div>
				</div>
				<div className="container-message__bottom">
					<div className="container-message__bottom-header">
						WHAT IS WBN WEB PLATFORM FOR EXPORT? is an essential industrial tool to export manufacturer products:
					</div>
					<div className="container-message__bottom-content">
						<div className="container-message__bottom-left">
							<TextWrapped className="text-wrapped-wide">
								<ul>
									<li>- It's an international showcase for your products.</li>
									<li>- It's a constant presence of your factory in the world.</li>
									<li>- It's a world's Fair 24 hours/day 365 days/year.</li>
									<li>- It's the market tool used by your future distributor.</li>
								</ul>
							</TextWrapped>
						</div>
						<div className="container-message__bottom-right">
							<TextWrapped className="text-wrapped-wide">
								<ul>
									<li>- It's made according to international market needs.</li>
									<li>- It's defined in the ​​most important market languages.</li>
									<li>- It's your open door to export worldwide.</li>
									<li>- It's the right tool to increase your sales abroad.</li>
								</ul>
							</TextWrapped>
						</div>
					</div>

				</div>
			</div>
			<div className="container-image">
				<p style={{ margin: "0 30px", textAlign: "center" }}>WBN has quantity 25 B2B web platforms and representatives in China, Australia, Japan, Indonesia, UAE, Saudi Arabia, India, Africa, Egypt, Russia, Germany, United Kingdom, Italy, France, United States of America, Miami, Texas, California, Atlanta, New York, Mexico, Canada, Brazil, Chile and Peru to support everyone everywhere in the globe.</p>
				<img src={WBN_Network} alt='Collage Territories' />
			</div>
			<div className="container-team">
				<div className="container-team__title">
					<Button style={{height: "30px"}}>WBN OUR MANAGEMENT</Button>
				</div>
				<div className='container-team__members'>
					<div className="container-team__left">
						<div>
							<img src={PersonOne} alt='Christian Caballero CEO WBNB2B' />
							<div className="container-team__header">
								<p>Christian L. Caballero</p>
								<p>CEO & PRESIDENT</p>
							</div>
							<p>
								Eng. CHRISTIAN CABALLERO, has a high end knowledge of Product Industrialization, Mechanical Engineering projects, Industrial Business Management and Industrial Worldwide Marketing. Graduated as professional Mechanical and Electrical Engineer (UNI 88), is the Founder CEO of WBN. With 30 years of international experience in Mechanical Design, industrial Manufacturing Process, Product Industrialization, Oil & Natural Gas Exploitation & installation, and Global Industrial B2B Marketing he has been directly involved in projects in Europe, Middle East, USA, Africa, Asia and Latinamerica.
							</p>
						</div>
					</div>
					<div className="container-team__right">
						<div>
							<img src={PersonTwo} alt='Miguel Longobardi - Cofounder WBNB2B' />
							<div className="container-team__header">
								<p>Miguel A. Longobardi</p>
								<p>MANAGING DIRECTOR</p>
							</div>
							<p>
								MIGUEL ANGEL LONGOBARDI, graduated as professional Mechanical and Electrical Engineer (UNI 98). Master in Business Administration and Magister in Human Resources, is the Co-Owner Managing Director of WBN inc., has 25 years experience as CEO, business development manager, Member of Boards and Senior Advisor in several industries as education, fishing, construction and real estate. Expert in project's design, planning, implementation of business growth models, creation and management of competitive & innovative teams that support change management.
							</p>
						</div>
					</div>
				</div>
			</div>
			<div className="container-b2b-tips">
				<div className="container-team__title">
					<Button style={{minHeight: "30px"}}>B2B TIPS BY OUR CEO - A GUIDE TO EXPORT PRODUCTS INTO THE GLOBAL MARKET</Button>
				</div>
        <TipSummary/>
			</div>
			<WBNMap />
		</div>
	)
};

export default AboutUs;